import { post } from "../utils/FetchV2.util";

export const sendEventService = async ({
  event,
  source,
  eventPayload,
}: {
  event: string;
  source: string;
  eventPayload: Record<string, any>;
}) => {
  try {
    const body = {
      event,
      source,
      event_payload: eventPayload,
      user_id: 1,
    };
    const response = await post({
      service: "userManagementEngine",
      endpoint: `/events/v2/web/send-event`,
      body,
    });

    return response;
  } catch (error) {
    throw error;
  }
};
